import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Use useNavigate here
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth"; // Import necessary Firebase methods
import dimsumtreatsLogo from './assets/logo.png';
import { db } from "../src/firebase-config"; // Import Firestore database
import { collection, query, where, getDocs } from "firebase/firestore";
import './AdminSidebar.css';
import { VscChevronDown } from "react-icons/vsc";

const AdminSidebar = () => {
    const [openMenu, setOpenMenu] = useState({});
    const [usertype, setUsertype] = useState('');
    const location = useLocation(); // Get the current path
    const navigate = useNavigate(); // Replace useHistory with useNavigate

    const toggleSubmenu = (menuName) => {
        setOpenMenu((prev) => ({
            ...prev,
            [menuName]: !prev[menuName],
        }));

        // Toggle the arrow direction
        const arrowElement = document.querySelector(`#${menuName}-arrow`);
        if (arrowElement) {
            arrowElement.classList.toggle('rotate');
        }
    };

    const isActive = (path) => location.pathname === path; // Check if path is active

    const handleLogout = async () => {
        const auth = getAuth(); // Get Firebase auth instance
        try {
            await signOut(auth); // Sign out the user
            console.log("User signed out");
            navigate("/pages/AccountsLoginPage"); // Redirect to login page after logout
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    useEffect(() => {
        console.log('Page has changed to:', location.pathname);
        
        const fetchUsertype = async () => {
            const auth = getAuth();
            const user = auth.currentUser;

            const unsubscribe = onAuthStateChanged(auth, async (user) => {
                if (user) {
                    console.log("Currently logged-in user:", user.email);

                    // Query Firestore to get user details based on the email
                    const usersRef = collection(db, "users");
                    const q = query(usersRef, where("email", "==", user.email));
                    const querySnapshot = await getDocs(q);

                    // Check if user data exists in Firestore
                    if (!querySnapshot.empty) {
                        const userDoc = querySnapshot.docs[0].data(); // Get the first matched document
                        console.log("Fetched user document:", userDoc);
                        setUsertype(userDoc.usertype); // Set the usertype in state
                    } else {
                        console.log("No user found in the users collection");
                    }
                }
            });

            // Cleanup the listener on component unmount
            return () => unsubscribe();
        };

        fetchUsertype(); // Call the async function to fetch the user type

    }, [location]);
    
    return (
        <div className="admin-sidebar">
            <div className="header">
                <Link to="/pages/Homepage">
                    <img src={dimsumtreatsLogo} className="logo" alt="Dimsum Treats logo" />
                </Link>
                <h4>Inventory Management</h4>
            </div>
            <ul>
                {/* Inventory Section */}
                <li>
                    <div onClick={() => toggleSubmenu("inventory")} id="inventory-arrow-container">
                        <i className="arrow-icon" id="inventory-arrow"><VscChevronDown /></i> <span>Inventory</span>     
                    </div>
                    <ul className={openMenu.inventory ? "active" : ""}>
                        {(usertype === "Admin" || usertype === "Manager" || usertype === "Employee") && (
                        <li>
                            <Link
                                to="/pages/InventoryIngredients"
                                className={isActive("/pages/InventoryIngredients") ? "active-link" : ""}
                            >
                                Ingredients List
                            </Link>
                        </li>
                        )}
                        {(usertype === "Admin" || usertype === "Manager" || usertype === "Employee") && (
                        <li>
                            <Link
                                to="/pages/InventoryProducts"
                                className={isActive("/pages/InventoryProducts") ? "active-link" : ""}
                            >
                                Products List
                            </Link>
                        </li>
                        )}
                        {(usertype === "Admin" || usertype === "Manager" || usertype === "Employee") && (
                        <li>
                            <Link
                                to="/pages/InventoryAddItems"
                                className={isActive("/pages/InventoryAddItems") ? "active-link" : ""}
                            >
                                Add Product Quantity
                            </Link>
                        </li>
                        )}
                        {(usertype === "Admin" || usertype === "Manager" || usertype === "Employee") && (
                        <li>
                            <Link
                                to="/pages/InventoryRemoveItems"
                                className={isActive("/pages/InventoryRemoveItems") ? "active-link" : ""}
                            >
                                Remove Ingredient Quantity
                            </Link>
                        </li>
                        )}
                        {(usertype === "Admin" || usertype === "Manager") && (
                        <li>
                        <Link
                            to="/pages/InventoryItemLogs"
                            className={isActive("/pages/InventoryItemLogs") ? "active-link" : ""}
                        >
                            Item Logs
                        </Link>
                    </li>
                        )}
                        {(usertype === "Admin" || usertype === "Manager") && (
                        <li>
                        <Link
                            to="/pages/InventoryPriceLogs"
                            className={isActive("/pages/InventoryPriceLogs") ? "active-link" : ""}
                        >
                            Price Logs
                        </Link>
                    </li>
                        )}
                    </ul>
                </li>
                {/* Input Section */}
                <li>
                    <div onClick={() => toggleSubmenu("input")} id="input-arrow-container">
                        <i className="arrow-icon" id="input-arrow"><VscChevronDown /></i> <span>Suppliers</span>
                    </div>
                    <ul className={openMenu.input ? "active" : ""}>
                        {(usertype === "Admin" || usertype === "Manager" || usertype === "Employee") && (
                        <li>
                            <Link
                                to="/pages/SuppliersAddReceipt"
                                className={isActive("/pages/SuppliersAddReceipt") ? "active-link" : ""}
                            >
                                Add Supplier Receipt
                            </Link>
                        </li>
                        )}
                        {(usertype === "Manager" || usertype === "Admin") && (
                        <li>
                            <Link
                                to="/pages/SuppliersHistory"
                                className={isActive("/pages/SuppliersHistory") ? "active-link" : ""}
                            >
                                Supplier Receipt History
                            </Link>
                        </li>
                        )}
                    </ul>
                </li>

                {/* Orders Section */}
                <li>
                    <div onClick={() => toggleSubmenu("orders")} id="orders-arrow-container">
                        <i className="arrow-icon" id="orders-arrow"><VscChevronDown /></i> <span>Orders</span>
                    </div>
                    <ul className={openMenu.orders ? "active" : ""}>
                        {(usertype === "Admin" || usertype === "Manager" || usertype === "Employee") && (
                        <li>
                            <Link
                                to="/pages/OrderGenerateReceipt"
                                className={isActive("/pages/OrderGenerateReceipt") ? "active-link" : ""}
                            >
                                Generate Order Receipt
                            </Link>
                        </li>
                        )}
                        {(usertype === "Manager" || usertype === "Admin") && (
                        <li>
                            <Link
                                to="/pages/OrderHistory"
                                className={isActive("/pages/OrderHistory") ? "active-link" : ""}
                            >
                                Order Receipt History
                            </Link>
                        </li>
                        )}
                    </ul>
                </li>

                {/* Accounts Section */}
                <li>
                    <div onClick={() => toggleSubmenu("account")} id="account-arrow-container">
                        <i className="arrow-icon" id="account-arrow"><VscChevronDown /></i> <span>Account</span>
                    </div>
                    <ul className={openMenu.account ? "active" : ""}>
                        {usertype === "Admin" &&(
                        <li>
                            <Link
                                to="/pages/AccountsRegisterPage"
                                className={isActive("/pages/AccountsRegisterPage") ? "active-link" : ""}
                            >
                                Register an Account
                            </Link>
                        </li>
                        )}
                        {usertype === "Admin" &&(
                        <li>
                            <Link
                                to="/pages/AccountsManageUsers"
                                className={isActive("/pages/AccountsManageUsers") ? "active-link" : ""}
                            >
                                Manage Users
                            </Link>
                        </li>
                        )}
                        <li>
                            <div
                                onClick={handleLogout} // Handle log out on click
                                className={isActive("/pages/AccountsLoginPage") ? "active-link" : ""}
                            >
                                Log Out
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default AdminSidebar;